import React from "react";
import NewOrExistingAuth from "../../../common/basic_auth/NewOrExistingAuth";
import WizardSchedule from "../../../common/WizardSchedule";
import { alwaysTrue, objectTypeNameAndImportSourceMustNotBeEmpty } from "../../../../utils/wizardCommonValidations";
import UserAssetStart from "./pages/UserAssetStart";
import {userNamePasswordNotEmpty} from "../../assets_wizard_validations"
import ConfirmUserImport from "./pages/ConfirmUserImport";
import { JiraServiceManagementIcon } from "@atlaskit/logo";

const wizard = {
  title: "Assets Jira User Import",
  id: "JSM_ASSETS_USER_IMPORT",
  description: "Import Jira Users into Assets",
  category: "JSM_ASSET_IMPORT",
  icon: <JiraServiceManagementIcon/>,
  pages: [
    {
      id: "1",
      label: "Credentials",
      percentageComplete: 0,
      status: "visited",
      href: "#",
      content: <NewOrExistingAuth info="Credentials are required for the app to read users and create asset import configurations."/>,
      validate: userNamePasswordNotEmpty
    }, 
    {
      id: "2",
      label: "Import Configuration",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <UserAssetStart />,
      validate: objectTypeNameAndImportSourceMustNotBeEmpty,
    }, 
    {
      id: "3",
      label: "Schedule",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <WizardSchedule />,
      validate: alwaysTrue
    }, 
    {
      id: "4",
      label: "Summary",
      percentageComplete: 0,
      status: "unvisited",
      href: "#",
      content: <ConfirmUserImport />,
      validate: alwaysTrue

    }
  ],
};
export default wizard;
